import { render } from "./AppFormBlock.vue?vue&type=template&id=2b25a862&lang=pug"
import script from "./AppFormBlock.vue?vue&type=script&lang=js"
export * from "./AppFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "P:\\Marina\\beta.smolenskoe-spb.ru\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__